<template>
  <div>
    <page-header :title="$t('bill.text_38')" />
    <page-body>
      <rate-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import RateList from './components/List'

export default {
  name: 'RateSetIndex',
  components: {
    RateList,
  },
  data () {
    return {
      listId: 'RateSetList',
    }
  },
}
</script>
